export const localeCurrencySymbol = Object.freeze({
  sv_SE: "SEK",
  da_DK: "DKK",
  nl_NL: "€",
  nl_BE: "€",
  fr_BE: "€",
  fr_FR: "€",
});

export const localeCurrency = Object.freeze({
  sv_SE: "SEK",
  da_DK: "DKK",
  nl_NL: "EUR",
  nl_BE: "EUR",
  fr_BE: "EUR",
  fr_FR: "EUR",
});

export const currencySymbols = Object.freeze({
  SEK: "SEK",
  DKK: "DKK",
  EUR: "€",
});

export const localeCurrencySymbolUnique: CurrencySymbol[] = ["DKK", "€", "SEK"];
export const localeCurrencyCodeUnique: CurrencyCode[] = ["DKK", "EUR", "SEK"];

export type LocaleCurrency = keyof typeof localeCurrency;
export type CurrencyCode = "DKK" | "EUR" | "SEK";
export type CurrencySymbol = "€" | "DKK" | "SEK";
